import React, {useEffect, useState} from "react";
import {useCourses} from "../useAppPullState";


export const useFilteredCourses = () => {
    const golfCoursesList = useCourses();


    return {
        filteredGolfCourses: golfCoursesList,
    };
};
